import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.svg";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/github (2).svg';

export const Footer = () => {

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center ">
          <MailchimpForm />
          <Col size={12} sm={6}>
            {/* <img src={logo} alt="Logo" /> */}
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon show1">
            <a href="https://www.linkedin.com/in/nimesh-kavinda-k0000/"><img src={navIcon1}/></a>
                <a href="https://www.facebook.com/nimesh.liyanage.7140"><img src={navIcon2}/></a>
                <a href="https://instagram.com/_nime_sh_?igshid=MzNlNGNkZWQ4Mg=="><img src={navIcon3}/></a>
                <a href="https://github.com/nimeshkk"><img src={navIcon4}/></a>
            </div>
            <p></p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}